import { Theme } from '@mui/material';

export const styles = {
  root: {
    overflow: 'hidden',
  },
  wrapper: (theme: Theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: '80px',
    [theme.breakpoints.down('lg')]: {
      height: 'calc(100svh)',
    },
  }),
};
